import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_geometry_green/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-e932c6ac51.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-96202e0448.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-49c68adc13.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-155c1e963a.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-e282bc068c.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-7627cfe771.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-86e30ab3e4.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-ef8cdfc7af.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-729944dd6d.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-10198ebf6c.png'; };
